import { FieldShell } from './FieldShell';
import { useDomFieldId } from './_useFieldName';

const BLOCK = 'LStudio__app_field';

export const WEEKDAYS = [
    { id: 'mon', label: 'Lunes', short: 'Lun' },
    { id: 'tue', label: 'Martes', short: 'Mar' },
    { id: 'wed', label: 'Miércoles', short: 'Mié' },
    { id: 'thu', label: 'Jueves', short: 'Jue' },
    { id: 'fri', label: 'Viernes', short: 'Vie' },
    { id: 'sat', label: 'Sábado', short: 'Sáb' },
    { id: 'sun', label: 'Domingo', short: 'Dom' },
];

const PRESETS = [
    { id: 'week', label: 'Semana', days: ['mon', 'tue', 'wed', 'thu', 'fri'] },
    { id: 'weekend', label: 'Fin de semana', days: ['sat', 'sun'] },
    { id: 'all', label: 'Todos los días', days: WEEKDAYS.map((day) => day.id) },
];

export const FieldWeekdays = ({
    id, label, hint, error,
    value = [], onChange, showPresets = true,
    isDisabled = false, span = 2,
}) => {
    const DOM_ID = useDomFieldId(id);

    const onToggle = (dayId) => {
        onChange?.(value.includes(dayId) ? value.filter((day) => day !== dayId) : [...value, dayId]);
    };

    const onPreset = (days) => {
        const isSame = days.length === value.length && days.every((day) => value.includes(day));
        onChange?.(isSame ? [] : days);
    };

    return (
        <FieldShell id={DOM_ID} label={label} error={error} span={span} isDisabled={isDisabled} hint={hint}>
            <div className={`${BLOCK}__weekdays`}>
                {WEEKDAYS.map((day) => (
                    <button
                        key={day.id}
                        type="button"
                        title={day.label}
                        className={`${BLOCK}__weekday`}
                        data-on={value.includes(day.id)}
                        aria-pressed={value.includes(day.id)}
                        disabled={isDisabled}
                        onClick={() => onToggle(day.id)}
                    >
                        {day.short}
                    </button>
                ))}
            </div>

            {showPresets && (
                <div className={`${BLOCK}__weekdays_presets`}>
                    {PRESETS.map((preset) => {
                        const isActive = preset.days.length === value.length && preset.days.every((day) => value.includes(day));
                        return (
                            <button
                                key={preset.id}
                                type="button"
                                disabled={isDisabled}
                                data-on={isActive}
                                aria-pressed={isActive}
                                onClick={() => onPreset(preset.days)}
                            >
                                {preset.label}
                            </button>
                        );
                    })}
                </div>
            )}

            <div className={`${BLOCK}__weekdays_count`}>{value.length} de 7 días</div>
        </FieldShell>
    );
};
